<script lang="ts">
  import { Tooltip } from "sveltestrap"

  export let tooltipId: string
  let className = '';
  export { className as class };
</script>

<img id={tooltipId} class={`icon-small ${className}`} src="/icons/question.svg" alt="placeholder"/>
<Tooltip animation={false} target={tooltipId}><slot/></Tooltip>
